export const workflowParams = Object.freeze({
  USER_WORKFLOW: {
    useUserWorkflowId: true,
    useSegmentWorkflowId: false,
  },
  SEGMENT_WORKFLOW: {
    useUserWorkflowId: false,
    useSegmentWorkflowId: true,
  },
});

export const workflow = Object.freeze({
  USER_WORKFLOW: 'USER_WORKFLOW',
  SEGMENT_WORKFLOW: 'SEGMENT_WORKFLOW',
});
